module.exports = __webpack_public_path__ + "assets/media/evening.2846f0a5.mp3";